/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import {
  MaterialStatus,
  newUploaderResponse,
  GetVideoMetaInfoReq,
  VideoMetaInfo,
  GetVideoMetaInfoResp,
  STS_TOKEN,
  MaterialType,
  CreativeRatioType,
  CreativeGenerateCode,
  MachineAuditItem,
  CreativeInfo,
  CreativeGenerateResponse,
  MaterialSource,
  NativeMaterialItem,
  LibraryImageItem,
  LibraryVideoItem,
  TeaConfig,
  videoStage, VIDEO_STAGE,
} from "./../../../const/media";
import {
  getVideoInfo,
  preAudit,
  uploadCreative,
  uploadImage
} from './../../../service/media';
import { getCutFormatQuery, completeImageUrl, preloadPoster, sleep } from './../../../utils/creativeUtil';
import { compressImage } from './../../../utils/tool';
import store from './../../../store/index';
import mutations from './../../../store/modules/ads_creative/mutations';
import AsyncRequest, { PollingMethod } from './../../../utils/polling';
import apis from './../../../const/apis';
import { Response } from './../../../utils/request/index';
import { trackEvent } from './../../../tea-tracker';
import { captureError, customBizReport } from './../../../utils/errorLogger';
import { SET_CREATIVE_LIST_STATUS } from './../../../store/types/index';
import { CREATIVE_LIST_STATUS } from './../../../const/common';
import adsCreative from './../../../store/modules/ads_creative/index';
import campaignStore from './../../../store/modules/campaign/index';
import Request from './../../../utils/request/index';
import BytedUploader, { STSToken, UploadResultVideoMeta } from '@byted/uploader-oversea';
import accountState from './../../../store/modules/account/index';
import  { computed } from '@vue/composition-api';
import { imageUploadService } from './utils';

const handleVideoInfo = async (vid: string) => {
  const { data } = await uploadCreative(vid);
  const { video_info } = data;
  const { name } = video_info;
  const { video_list, poster_url, video_duration } = await getVideoInfo({ vid });
  const videoList = Object.values(video_list).sort((o1, o2) => o2.bitrate - o1.bitrate).map(item => item);
  const { bitrate, vheight, vwidth, size, main_url } = videoList?.[0] || {};
  return {
    name,
    bitrate,
    main_url,
    size,
    vid,
    width: vwidth,
    cover_url: poster_url,
    duration: video_duration,
    height: vheight
  };
};
export class ImageMaterial {
  file: File;
  status: MaterialStatus;
  url: string;
  post_url: string;
  info: {

  };
  auditInfo: MachineAuditItem;
  progress: number;

  constructor(opt: { file?: File; source: MaterialSource; url?: string; post_url?: string }) {
    this.file = opt?.file as File;
    this.status = opt?.source === MaterialSource.LIBRARY ? MaterialStatus.UPLOAD_SUCCESS : MaterialStatus.INIT;
    this.url = completeImageUrl(opt?.url as string) || '';
    this.post_url = completeImageUrl(opt?.post_url as string) || '';
    this.info = {};
    this.auditInfo = {} as MachineAuditItem;
    this.progress = 0;
  }
  async upload(disableStageUpdate) {
    try {
      const st = Date.now();
      this.status = MaterialStatus.UPLOADING;
      this.file = await compressImage(this.file);
      const formats = getCutFormatQuery();
      const { original_img_uri, image_info } = await uploadImage({
        formats,
        image_data: this.file
      });
      this.url = completeImageUrl(original_img_uri);
      this.info = image_info;

      // camera roll图片上传
      if (this.url) {
        trackEvent('adp_waplite_duration', {
          [TeaConfig.CAMERA_ROLL.IMAGE_UPLOAD]: Date.now() - st
        });
      }
      this._onSuccess(disableStageUpdate);
    } catch (e) {
      console.log('[image upload error]', e);
      this._onError();
    }
  }

  private _onSuccess(disableStageUpdate = false) {
    if (!disableStageUpdate) {
      adsCreative.mutations.setVideoStage(videoStage.OPTIMIZE);
      campaignStore.mutations.setVideoStage(videoStage.OPTIMIZE);
    }
    if (!this.url) {
      this._onError();
    } else {
      this.status = MaterialStatus.UPLOAD_SUCCESS;
    }
  }
  private _onError() {
    this.status = MaterialStatus.UPLOAD_FAIL;
  }
}

interface VideoOption {
  file?: File;
  source: MaterialSource;
  type: MaterialType; // 用于区分是使用视频素材去生成创意视频还是使用图片素材生成创意视频
  videoInfo?: VideoMaterial['info']; // 用于tt video
  imageList?: string[]; // 用于图片生成创意视频,
  errorHandler?: any;
  retry?: any;
}
export class VideoMaterial {
  file: File;
  status: MaterialStatus;
  videoUploader: null | { on: any; addFile: any; start: any };
  info: CreativeInfo; // 用来预览的视频信息 // todo 确认哪里有用到
  vid: string; // 当前用来预览的视频vid
  auditInfo: {
    summary: string[];
    results: MachineAuditItem;
  };
  progress: number; // 范围[0,1]
  source: MaterialSource;
  imageList: string[];
  type: MaterialType; // 用户上传素材类型
  timer: NodeJS.Timeout;
  uidList: string[]; // 创意视频生成任务id, uid[]
  uid: string; // 当前vid对应的taskid
  errorHandler?: any;
  retry?: any;
  stopped?: boolean;

  constructor(opt: VideoOption) {
    this.file = opt.file as File;
    this.status = opt.source === MaterialSource.LIBRARY ? MaterialStatus.UPLOAD_SUCCESS : MaterialStatus.INIT;
    this.videoUploader = null;
    this.info = opt?.videoInfo || {} as VideoMaterial['info'];
    this.vid = opt?.videoInfo?.vid || '';
    this.auditInfo = {} as VideoMaterial['auditInfo'];
    this.progress = 0;
    this.source = opt?.source;
    this.imageList = opt?.imageList || [];
    this.type = opt?.type;
    this.timer = {} as NodeJS.Timeout;
    this.uidList = [];
    this.uid = '';
    this.errorHandler = opt?.errorHandler;
    this.retry = opt?.retry;
    this.stopped = false;

    if (this.isVideo && this.vid && !this.info?.main_url) {
      this.getVideoDetail();
    }
  }
  async upload() {
    if (this.source !== MaterialSource.CAMERA_ROLL || this.type !== MaterialType.VIDEO) {
      return;
    }
    try {
      const aadvid = computed(() => accountState.getters.adverId(accountState.state))
      const st = Date.now();
      this.status = MaterialStatus.UPLOADING;
      const VIDEO_UPLOAD_STS_TOKEN = await this.getVideoUploadToken();
      const bytedUploader = new BytedUploader({
        // userId === advId
        userId: aadvid.value,
        // ttam appId
        appId: 4697, 
        videoHost: 'https://vod-upload-sg.tiktok.com',
        imageHost: 'https://imagex-upload-sg.tiktokv.com',
        videoConfig: {
          spaceName: 'ad_site',
          processAction: [
            {
              name: 'Snapshot',
              input: {
                SnapshotTime: 0,
              },
            },
            {
              name: 'StartWorkflow',
              input: {
                TemplateId: 'c3841b3122fd460db2bc99a6ec131cb8',
              }
            },
          ],
        },
        imageConfig: {
          serviceId: '375lmtcpo0'
        },
      });
      this.videoUploader = bytedUploader;
      const fileKey = this.videoUploader?.addFile({
        file: this.file,
        stsToken: VIDEO_UPLOAD_STS_TOKEN,
        type: MaterialType.VIDEO
      });
      this.videoUploader?.start(fileKey);
      this.videoUploader?.on('complete', async(info): Promise<any> => {
        mutations.setVideoUploaded(true);
        console.log('[video upload success]', info);
        const VIDEO_DURATION = info?.uploadResult?.VideoMeta?.Duration;
        // camera roll视频上传时长
        // check for valid video duration
        if(VIDEO_DURATION) {
          if (!this.validate_video_duration(VIDEO_DURATION)) {
            this.handleInvalidVideo();
            return;
          } 
        } else {
          // For the return result of video upload, only Vid will be returned by default
          // Manually call get_video_meta_data api to fetch video meta data
          let video_duration;
          const video_meta_info = await this.fetchVideoMetaData(info?.Vid);
          if(!video_meta_info){
            const[videoMeta, coverUri] = await this.generateDefaultMetaInfo(this.file);
            video_duration = videoMeta?.Duration;
          } else {
            video_duration = video_meta_info?.duration
          }
          if(!this.validate_video_duration(video_duration)) {
            this.handleInvalidVideo();
            return;
          }
        }
        trackEvent('adp_waplite_duration', {
          [TeaConfig.CAMERA_ROLL.VIDEO_UPLOAD]: Date.now() - st
        });
        this._onSuccess(info?.uploadResult);
      });
      this.videoUploader?.on('progress', (infor) => {
        // Ouput upload progress
        console.log('[Video upload progress]: ', infor.percent)
      });
      this.videoUploader?.on('error', (): void => {
        this.errorHandler()

        console.log('[video upload error]');
        this._onError();
      });
    } catch (e) {
      console.log('~', e);
      this._onError();
    }
  }
  /** 根据vid拉取对应视频信息 */
  async getVideoDetail() {
    handleVideoInfo(this.vid).then(({ main_url }) => {
      this.info = {
        ...this.info,
        main_url
      };
    });
  }
  async audit() {
    if (this.stopped) {
      return
    }
    const st = Date.now();
    if (this.isVideo) {
      await sleep(3000);
    }
    const { summary_results, material_results } = await preAudit([{
      videos: this.isVideo ? [this.vid] : [],
      images: this.isVideo ? [] : this.imageList,
      display_name: []
    }]);
    this.auditInfo = {
      summary: summary_results,
      results: material_results?.[0]?.videos?.[0]
    };

    const param = this.isVideo ? TeaConfig.CAMERA_ROLL.VIDEO_AUDIT : TeaConfig.CAMERA_ROLL.IMAGE_AUDIT;
    trackEvent('adp_waplite_duration', {
      [param]: Date.now() - st
    });

  }
  /** origin素材是否是视频 */
  private get isVideo() {
    return this.type === MaterialType.VIDEO;
  }
  generateReadyInfo(data: CreativeGenerateResponse, taskIds: string[]) {
    if (taskIds?.length !== 1) {
      captureError(new Error(`TaskIds invalid length, taskIds=${taskIds?.join(';')}.`));
      return { ready: false, info: { vid: '' } };
    }

    return { ready: data[taskIds[0]]?.code === CreativeGenerateCode.SUCCESS, info: data[taskIds[0]].data };
  }
  async generate() {
    if (this.stopped) {
      return
    }
    if (this.source === MaterialSource.TIKTOK_VIDEO) {
      return;
    }

    const st = Date.now();
    this._change2Optimizing();
    const start = Date.now();
    clearInterval(this.timer);
    this.timer = setInterval(() => {
      const percent = (Date.now() - start) / (10 * 1000);
      this.progress = Math.min(percent, 0.9);
    }, 1000);
    const materialList = this.isVideo ? [{
      type: MaterialType.VIDEO,
      vid: this.vid
    }] : this.imageList.map(url => ({
      url,
      type: MaterialType.IMAGE
    }));

    const formats = [{
      index: 0,
      category: 'fastCreation',
      material_list: materialList,
      target_info: {
        template: CreativeRatioType.VERTICAL
      }
    }];
    const generateInstance = new AsyncRequest({
      upstreamData: { formats },
      createTaskUrl: apis.creative.videoRender,
      pollingTaskUrl: apis.creative.videoReadyCheck,
      taskName: 'uid_list',
      method: PollingMethod.POST,
      extractTaskId: (res: Response<{
        uid_list: {
          id: number;
          template: CreativeRatioType;
          uid: string;
        }[];
      }>) => res?.data?.uid_list?.map(item => item.uid),
      successCheck: (res: Response<CreativeGenerateResponse>, taskIds: string[]) => {
        const { data } = res;
        const { ready } = this.generateReadyInfo(data, taskIds);
        return ready;
      },
      failureCheck: (res: Response<Record<string, { code: CreativeGenerateCode }>>) => Object.values(res?.data || {})?.every(item => item.code === CreativeGenerateCode.FAIL)
    });

    const { data }: { data: CreativeGenerateResponse } = await generateInstance.create();
    // todo-kad catch clearinterval
    clearInterval(this.timer);
    const { info } = this.generateReadyInfo(data, generateInstance.taskIds);
    // 创意预览默认展示竖版
    this.vid = info?.vid || '';
    try {
      const videoInfo = await handleVideoInfo(this.vid);
      this.info = videoInfo;

      this.uid = Object.entries(data).find(item => item?.[1]?.data?.vid === this.vid)?.[0] as string;

      // 判断是否视频类型出现更换, 切换了 objective 等
      if (adsCreative.state.identity.activeSource.value !== this.source) {
        return;
      }

      await this._change2Optimized(videoInfo);
      try {
        mutations.setVideoOptimization(true);
      } catch (e) {
        console.error(e);
      }
    } catch (e) {
      campaignStore.mutations.setVideoStage(VIDEO_STAGE.INIT);
    }
  }
  async optimize() {
    if (this.stopped) {
      return
    }
    try {
      await this.audit();
      await this.generate();
    } catch (e) {
      clearInterval(this.timer);
      await this._change2OptimizeFailed();
    }
  }
  stopVideoCreation() {
    this.stopped = true
  };
  /**
   * 处理开始创意视频生成的逻辑处理
   */
  private _change2Optimizing() {
    this.progress = 0;
    this.status = MaterialStatus.OPTIMIZING;
    mutations.setClearCreativeData();
    store.commit(`${SET_CREATIVE_LIST_STATUS}`, CREATIVE_LIST_STATUS.LOADING);
  }
  /**
   * 创意视频生成成功的逻辑处理
   */
  private async _change2Optimized(creativeInfo: CreativeInfo) {
    this.progress = 1;
    this.status = MaterialStatus.OPTIMIZE_SUCCESS;
    adsCreative.mutations.setVideoStage(videoStage.FINISH);
    campaignStore.mutations.setVideoStage(videoStage.FINISH);
    mutations.setCreativeData(creativeInfo);
    mutations.setClearSelectedVideo();
    store.commit(`${SET_CREATIVE_LIST_STATUS}`, CREATIVE_LIST_STATUS.READY);
    customBizReport('RenderVideo', { tags: { code: '0' } });
  }
  /**
   * 创意视频生成失败的逻辑处理
   */
  private async _change2OptimizeFailed() {
    this.status = MaterialStatus.OPTIMIZE_FAIL;
    this?.retry();
    store.commit(`${SET_CREATIVE_LIST_STATUS}`, CREATIVE_LIST_STATUS.ERROR);
    customBizReport('RenderVideo', { tags: { code: '-1', message: '创意视频生成失败' } });
  }
  private async _onSuccess({ Vid }: newUploaderResponse) {
    if (this.stopped) {
      return
    }
    try {
      this.vid = Vid;
      this.status = MaterialStatus.UPLOAD_SUCCESS;
      await this.optimize();
    } catch (e) {
      this._onError();
    }
  }
  private async _onError() {
    this.status = MaterialStatus.UPLOAD_FAIL;
  }

  private async getVideoUploadToken(): Promise<STSToken> {
    try {
      const response = await Request.get<Response<{token: string}>>(apis.videoUploadToken, {});
      const token: STS_TOKEN  = JSON.parse(response?.data?.token);
      return {
        CurrentTime: token?.CurrentTime,
        ExpiredTime: token?.ExpiredTime,
        SessionToken: token?.SessionToken,
        AccessKeyId: token?.AccessKeyID,
        SecretAccessKey: token?.SecretAccessKey,
      };
    } catch(e) {
      console.log('Error in retrieving STS token: ', e);
    }
  }

  private async fetchVideoMetaData(videoId: string): Promise<VideoMetaInfo> {
    try {
      const { data } = await Request.post<Response<GetVideoMetaInfoResp>>(apis.videoMetaInfo, {vids: [videoId]} as GetVideoMetaInfoReq);
      return data?.VideoInfoMap[videoId];
    } catch (e) {
      console.log('Error in manually fetching video meta data: ', e);
    }
  }

  private generateDefaultMetaInfo = (file: File): Promise<[ UploadResultVideoMeta, string ]> => {
    return new Promise((resolve, reject) => {
      try {
        const video = document.createElement('video');
        video.preload = 'auto';
        const reader = new FileReader();
        video.addEventListener('loadeddata', async () => {
          const posterBitmap = await window.createImageBitmap(video);
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('bitmaprenderer')!;
          canvas.width = posterBitmap.width;
          canvas.height = posterBitmap.height;
          ctx.transferFromImageBitmap(posterBitmap);
          const blob = await new Promise<Blob | null>(resolve => canvas.toBlob(resolve, 'image/jpeg'));
          console.log('blob', blob);
          if (!blob) {
            return;
          }
          const poster = new File([blob], file.name + 'screenshot.jpg')
          const posterResult = await imageUploadService(poster);
          if (!posterResult) {
            return;
          }
          resolve([
            {
              Width: canvas.width,
              Height: canvas.height,
              Duration: video.duration,
              FileType: 'MP4',
              Md5: '',
              Format: 'MP4',
              Uri: '',
              Bitrate: (8 * file.size) / video.duration,
              Size: file.size,
            },
            posterResult.webUri,
          ]);
        });
        reader.addEventListener('load', () => {
          video.src = reader.result as string;
          video.currentTime = 0;
        });
        reader.readAsDataURL(file);
      } catch (error) {
        reject(error);
      }
    });
  };

  private handleInvalidVideo(): void {
    this.errorHandler();
    this._onError();
  }

  private validate_video_duration(duration: bigint) {
    return duration > 5 && duration < 60;
  }
}

export type OriginMaterialInfo = NativeMaterialItem['video_info'] | LibraryImageItem | LibraryVideoItem;
/**
 * 这个class是为了处理素材封面图没加载出来时也需要骨架屏渲染
 */
export class OriginMaterial {
  info: OriginMaterialInfo;
  preloaded: boolean; // 是否预加载了封面图

  constructor(info: OriginMaterialInfo) {
    this.info = info;
    this.preloaded = false;

    this.handlePreload();
  }
  get isVideo() {
    return Boolean(this.info?.vid);
  }
  async handlePreload(): Promise<void> {
    this.preloaded = false;
    const poster = completeImageUrl(this.isVideo ? (this.info?.cover_url || this.info?.cover_uri) : this.info?.url || this.info?.web_uri);
    try {
      poster && await preloadPoster(poster);
      this.preloaded = true;
    } catch (e) {
      console.error(e);
    }
  }
}
